import type { RouteObject } from 'react-router'
import AuthGuard from '../components/AuthGuard'
import SEO from '../components/common/SEO'
import MainLayout from '../layouts/MainLayout'
import type { RouteName } from './route-definitions'
import { routeDefinitions } from './route-definitions'

/**
 * Converts our route definitions to React Router's RouteObject format
 */
function createRouteObject(routeName: RouteName): RouteObject {
  const definition = routeDefinitions[routeName]
  const Component = definition.component

  // Handle index route (home page)
  if (definition.path === '/') {
    return {
      index: true,
      element: (
        <>
          {definition.seo && <SEO {...definition.seo} />}
          <AuthGuard auth={definition.auth}>
            <Component />
          </AuthGuard>
        </>
      ),
    }
  }

  return {
    path: definition.path,
    element: (
      <>
        {definition.seo && <SEO {...definition.seo} />}
        <AuthGuard auth={definition.auth}>
          <Component />
        </AuthGuard>
      </>
    ),
  }
}

/**
 * Build routes array from our unified route definitions
 */
export const routes: RouteObject[] = [
  {
    element: <MainLayout />,
    children: [
      // Convert all routes to RouteObject format
      ...(Object.keys(routeDefinitions) as RouteName[]).map(routeName =>
        createRouteObject(routeName)
      ),
    ],
  },
]
